<script setup>
/**
 * FormSidebarBtn
 * A layout-specific wrapper for the base Button component.
 * Standardizes the appearance of secondary actions within the form sidebar.
 */
import Button from '@/common/Button.vue';
</script>

<template>
    <Button class="d-block btn-sm w-100 text-start">
        <slot />
    </Button>
</template>